import React, { useEffect } from 'react';
import { FaCrown, FaUtensils} from 'react-icons/fa';
import confetti from 'canvas-confetti';

const ThanksPage = ({ isModal = false, onClose }) => {
  useEffect(() => {
    // Create firework effect
    const duration = 5 * 1000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 40, zIndex: 9999 };

    function randomInRange(min, max) {
      return Math.random() * (max - min) + min;
    }

    const interval = setInterval(function() {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 50 * (timeLeft / duration);
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
      });
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
      });
    }, 250);

    return () => clearInterval(interval);
  }, []);

  const containerClasses = isModal
    ? "text-center p-8 bg-white/10 backdrop-blur-lg rounded-2xl shadow-xl border-2 border-blue-300 max-w-2xl w-full animate-fade-in-up"
    : "min-h-screen bg-gradient-to-b from-blue-500 to-blue-700 flex items-center justify-center p-4";

  return (
    <div className={containerClasses}>
      <div className="text-center">
        <div className="flex justify-center gap-4 mb-6">
          <FaCrown className="text-5xl text-yellow-300 animate-bounce" />
          <FaUtensils className="text-5xl text-yellow-300 animate-pulse" />
          <FaCrown className="text-5xl text-yellow-300 animate-bounce" />
        </div>
        
        <h1 className="text-4xl sm:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-500 mb-6 animate-scale-in">
          Welcome to Royalty!
        </h1>
        
        <div className="space-y-4 text-blue-100">
          <p className="text-xl animate-fade-in">
            Thank you for joining the Aziz Royal Club
          </p>
          <p className="text-lg animate-fade-in-delay">
            Get ready for an extraordinary culinary experience! 👨‍🍳✨
          </p>
          
          

          {isModal && (
            <button
              onClick={onClose}
              className="mt-6 bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-blue-900 font-bold py-2 px-6 rounded-full transform hover:scale-105 transition-all duration-300 shadow-lg"
            >
              Continue to Home
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ThanksPage;
